export default "__VITE_PUBLIC_ASSET__c7b9afcf__"